import { useCallback, useLayoutEffect, useState } from "react";

export const useResizeObserver = (ref: React.RefObject<HTMLElement>) => {
  const [sizes, setSizes] =
    useState<{ width: number; height: number } | null>(null);

  const handleResize = useCallback((entries) => {
    if (!Array.isArray(entries)) {
      return;
    }

    const entry = entries[0];
    setSizes({
      width: entry.contentRect.width,
      height: entry.contentRect.height,
    });
  }, []);

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    let resizeObserver = new ResizeObserver((entries) => handleResize(entries));
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [handleResize, ref]);

  return [sizes];
};
